import { render, staticRenderFns } from "./baidu-map.vue?vue&type=template&id=511e8c32"
import script from "./baidu-map.vue?vue&type=script&lang=js"
export * from "./baidu-map.vue?vue&type=script&lang=js"
import style0 from "./baidu-map.vue?vue&type=style&index=0&id=511e8c32&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('511e8c32')) {
      api.createRecord('511e8c32', component.options)
    } else {
      api.reload('511e8c32', component.options)
    }
    module.hot.accept("./baidu-map.vue?vue&type=template&id=511e8c32", function () {
      api.rerender('511e8c32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/old/baidu-map.vue"
export default component.exports